import React from 'react';
import {createRoot} from 'react-dom/client';
import {Analytics, type AnalyticsConfig} from './analytics';

const config = document.querySelector<HTMLMetaElement>('meta[name="fraud-attacks-analytics"]');
if (config) {
  const mount = document.createElement('div');
  mount.id = 'fraud-attacks-analytics';
  document.body.appendChild(mount);
  createRoot(mount).render(<Analytics config={JSON.parse(config.content) as AnalyticsConfig} />);
}
